import {SelectionListFilterModel} from '@/components/controls/selectionList/interfaces';

// Фильтр программных модулей по типу
export const pmoduleTypeFilter: SelectionListFilterModel = {
  name: 'Фильтр по типу модуля',
  keyFieldName: 'type',
  aliasFieldName: 'typeDescription',
};
